"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAddInteriorPrintablesToBookProject = void 0;
const typeguard_1 = require("../types/typeguard");
const ProjectAction_1 = require("./ProjectAction");
const addInteriorPrintablesToBookProjectRuleSet = {
  type: value => value === 'ADD_INTERIOR_PRINTABLES_TO_BOOK_PROJECT',
  numPrintablesToAdd: typeguard_1.isNumber,
  atIndex: (0, typeguard_1.optional)(typeguard_1.isNumber),
  mobile: (0, typeguard_1.optional)(typeguard_1.isBool)
};
const isAddInteriorPrintablesToBookProject = p => (0, ProjectAction_1.isBaseProjectAction)(p) && (0, typeguard_1.isType)(p, addInteriorPrintablesToBookProjectRuleSet);
exports.isAddInteriorPrintablesToBookProject = isAddInteriorPrintablesToBookProject;